import type {
    PhotoFilesResponse, PhotoFilesFilter, PhotoDetailResponse, PhotoDetailsResponse, MosaicPhotosResponse, MosaicLatestResponse
} from "../types"
import { instance } from "./api"
import { useAuthStore } from '../stores/t-auth';

async function listPhotoFiles(filters: PhotoFilesFilter) {
    const auth = useAuthStore();
    let filtros = '?';
    const params = [
        filters.start_date ? `start_date=${filters.start_date}` : '',
        filters.end_date ? `end_date=${filters.end_date}` : '',
        filters.tipo ? `tipo=${filters.tipo}` : '',
        filters.lat_zona ? `lat_zona=${filters.lat_zona}` : '',
        filters.lon_zona ? `lon_zona=${filters.lon_zona}` : '',
        filters.rad_zona ? `rad_zona=${filters.rad_zona}` : '',
        filters.predio_name ? `predio_name=${filters.predio_name}` : '',
        filters.predio_rad ? `predio_rad=${filters.predio_rad}` : '',
        filters.brightness ? `brightness=${filters.brightness}` : '',
        filters.event ? `event=${filters.event}` : ''
    ].filter(param => param).join('&');

    filtros += params;
    console.log("QueryString" + filtros);

    return await instance.get<PhotoFilesResponse>("/photos/files" + filtros, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}
async function getPhotoDetail(photoId: number) {
    const auth = useAuthStore();

    return await instance.get<PhotoDetailResponse>(`/photos/${photoId}/details`, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}
async function getPhotoDetails(idPhoto: number) {
    const auth = useAuthStore();

    const respuesta = await instance.get<PhotoDetailsResponse>("/photos/files/" + idPhoto, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
    return respuesta.data.Entries.Entry[0];
}


async function listMosaicPhotos(mosaicId: number) {
    const auth = useAuthStore();
    return await instance.get<MosaicPhotosResponse>(`/mosaics/${mosaicId}/photos`, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}

// Obtiene los mosaicos más recientes en las últimas `hours` horas
async function listLatestMosaics(hours: number, min_lon: number,  min_lat: number, max_lon: number, max_lat: number, limit: number = 1) {
    const auth = useAuthStore();
    return await instance.get<MosaicLatestResponse>(`/mosaics/latest?hours=${hours}&min_lon=${min_lon}&min_lat=${min_lat}&max_lon=${max_lon}&max_lat=${max_lat}&limit=${limit}`, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}

export default {
    listPhotoFiles,
    getPhotoDetail,
    getPhotoDetails,
    listMosaicPhotos,
    listLatestMosaics
};